export default {
  sponsors: [],
  pagination: {},
  sponsor: {}
}
